// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .ui-widget {
    font-size: 13px;
}

.brandName {
    left: 14px;
    top: 8px;
    font-size: 22px;
    color: #165788;
}

.app-name {
    color: white;
    margin-left: 8px;
    font-size: 28px;
    /* font-weight: bold; */
    vertical-align: -8px;
    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);
    font-family: Segoe UI;
    font-weight: 100;
}

.app-res {
    color: white;
    margin-left: 85px;
    font-size: 28px;
    /* font-weight: bold; */
    vertical-align: -8px;
    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);
    font-family: Segoe UI;
    font-weight: 100;
}

#sideoption a span {
    position: relative;
    top: 8px;
}

/* .sidebarDiv ul li ,.sidebarDiv ul li:hover {
     border: none !important; 
} */

.even-list-border a:hover {
    border-left: 5px solid #165788 !important;
    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.3);
    transform: scale(1.03);
    font-weight: bold;
}

.sidebarDiv {
    display: block;
    /* margin: 0.2em; */
    overflow-y: auto;
    overflow-x: hidden;
    position: relative;
    width: auto;
    /* height: 569px; */
    /* min-height: -webkit-fill-available; */
    /* max-height: 545px; */
    /* border-radius: 5px; */
    /* box-shadow: 3px 3px 15px 5px #888888;*/
}

.app-name-suffix {
    color: white;
    margin-left: 10px;
    font-size: 15px;
    /* font-weight: bold; */
    vertical-align: -8px;
    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);
    font-family: Segoe UI;
}

.sidebar-collapse {
    display: none !important;
    transition: all 0.2s ease-out !important;
}

.main-content-no-margin {
    margin-left: 0px !important;
    transition: all 0.2s ease-in-out;
}

.permitname-show {
    float: right !important;
    width: 20% !important;
    text-align: left !important;
}

/* :host ::ng-deep .clsBreadCrumbs{
    cursor: pointer;
    background-color: red !important;
    border: none !important;
    padding: 0px !important;
} */

.leftTopMenu:hover {
    background-color: transparent !important;
}

.wps-menu {
    width: 54px;
    height: 52px;
    float: left;
    background-color: #165788;
    text-align: center;
    padding-top: 14px;
}

.wps-menu {
    cursor: pointer;
    position: relative;
}

.wps-menu:hover {
    background-color: rgb(18, 84, 138);
}

.launcher-icon {
    height: 16px;
    width: 16px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    position: absolute;
}

.launcher-icon-close {
    height: 22px;
    width: 22px;
    margin-top: 11.5px;
    margin-bottom: 11.5px;
}

.app-launcher {
    position: fixed;
    box-shadow: rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px, rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px;
    animation-name: slideInFrames;
    position: absolute;
    z-index: 1000000;
    background-color: #fff;
    width: 320px;
    min-width: 320px;
    max-width: 320px;
    box-sizing: border-box;
    outline: none;
    overflow-y: auto;
    visibility: visible;
    pointer-events: auto;
    top: 0;
    left: 0;
    right: auto;
    height: 100vh;
    transform-origin: top left;
    animation-duration: .18s;
    animation-timing-function: ease;
}

.app-launcher-close-btn {
    background-color: transparent;
    box-sizing: border-box;
    border: 0;
    margin: 70px 5px 5px 5px;
    padding: 0;
    min-width: 0;
    width: 46px;
    height: 46px;
    text-align: center;
    cursor: pointer;
    transition: background-color 83ms linear;
}

/* .app-launcher-close-btn:hover {
    background-color: #dbdad7!important;
    transition: background-color .167s linear;
} */

.launcher-nav {
    margin: 0;
    outline: 0;
    box-sizing: border-box;
    position: relative;
    padding: 10px 22px 0 0px;
    transition: none;
    width: 310px;
    background-color: #ffffff;
}

.link-text {
    margin-top: 20px;
    margin-left: 9px;
    font-size: 24px;
}

.menu-list {
    display: block;
    list-style-type: disc;
    /* margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px; */
    /* padding-inline-start: 40px;  */
    list-style: none;
}

.menu-list-item {
    min-height: 40px;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    padding: 0;
    transition: background-color 267ms;
    margin-left: 8px;
    float: left;
    width: 100%;
    display: block;
    box-shadow: 2px 2px 5px rgba(204, 204, 204, 0.5);
    margin-top: 14px;
}

.menu-list-item a {
    display: flex;
    position: relative;
    box-sizing: border-box;
    border: 1px solid transparent !important;
    height: 48px;
    line-height: normal;
    text-decoration: none !important;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
    transition: border-color 83ms linear, box-shadow 83ms linear;
    color: rgb(0, 120, 215);
}

.menu-list-item a:hover {
    border-color: #f4f4f4 !important;
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);
    transition: border-color .167s linear, box-shadow .167s linear;
}

.menu-list-item-icon {
    font-size: 26px;
    color: inherit;
    margin: 10px 15px;
    display: inline-block;
    line-height: 1;
    font-style: normal;
    font-weight: 400;
    display: inline-block;
    text-decoration: none;
    text-align: center;
    font-variant: normal;
    text-transform: none;
    line-height: 1em;
    width: 30px;
}

.menu-list-item-text {
    color: #212121;
    font-size: 16px;
    margin-top: 14px;
    margin-left: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    white-space: nowrap;
    transition: color 83ms linear;
}

.border-right {
    /* border: 1px solid rgba(204, 204, 204, 0.5); */
    margin: -1px;
}

/* :host ::ng-deep .p-toast .p-toast-message {
    border: 1px solid #165788!important;
    border-radius: 3px;
    background: #f4f4f4!important;
    -moz-box-shadow: 3px 3px 12px #165788;
    -webkit-box-shadow: 3px 3px 12px #165788;
    box-shadow: 3px 3px 12px #165788
} */

:host ::ng-deep .p-toast .p-toast-message-content {
    padding: 0 !important;
    display: unset !important;
}

:host ::ng-deep .p-toast .p-toast-close-icon {
    color: #fff !important;
}

:host ::ng-deep .p-overlaypanel-content {
    background-color: #ffffff !important;
    color: #333333;
    padding: 0;
    border: 1px solid #c8c8c8;
    border-radius: 0;
}

.toast-header {
    background-color: #165788;
    color: #fff;
    padding: 1px 1px 1px 10px !important
}

.notification-count {
    margin-top: -10px;
    display: block;
    margin-right: 4px;
}

.notification {
    position: absolute;
    right: 1px;
    top: 2px;
    min-width: 26px;
    height: 26px;
    border-radius: 50%;
    font-size: 15px;
    font-weight: 100;
    text-align: center;
    color: #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);
    border: 1px solid rgba(0, 0, 0, .2);
    box-sizing: border-box;
    background-color: red;
}

.app-launcher-close {
    display: flex;
    font-weight: 600;
    background: transparent !important;
    border: 0;
    padding: 0;
    padding-left: 2px;
    min-width: 22px;
    height: auto;
    text-decoration: none !important;
    cursor: pointer;
    font-size: 22px;
    position: absolute;
    top: 11px;
    left: 284px;
}

.app-launcher-close:hover {
    background-color: lightgrey !important;
    transition: background-color .167s linear;
}

.bg-transparent {
    background: transparent !important;
}

.bg-fullscreen {
    background: url('/assets/Images/background.png') !important;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
}

.bg-full-grey {
    /* background: #f2f2f2 !important; */
    background: url('/assets/Images/background.png') !important;
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
}

.profile-initials {
    height: 32px;
    width: 32px;
    background-color: white;
    color: #165788;
    line-height: 32px;
    display: inline-block;
    margin-right: 5px;
    border-radius: 50%;
    text-align: center;
    font-weight: 100;
    font-family: Segoe UI;
    font-size: 16px;
}

:host ::ng-deep .p-toast-icon-close {
    position: absolute;
    top: 0.25em;
    right: 0.25em;
    cursor: pointer;
    display: inline-block !important;
}



:host ::ng-deep .p-toast,
.h5,
h5 {
    padding: 0 !important;
    padding-left: 5px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.css"],"names":[],"mappings":"AAAA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,QAAQ;IACR,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,+CAA+C;IAC/C,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,+CAA+C;IAC/C,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;GAEG;;AAEH;IACI,yCAAyC;IACzC,8CAA8C;IAC9C,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,wCAAwC;IACxC,uBAAuB;IACvB,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,uBAAuB;IACvB,oBAAoB;IACpB,+CAA+C;IAC/C,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;;;;GAKG;;AAEH;IACI,wCAAwC;AAC5C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,+FAA+F;IAE/F,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;IACN,OAAO;IACP,WAAW;IACX,aAAa;IAGb,0BAA0B;IAE1B,wBAAwB;IAExB,+BAA+B;AACnC;;AAEA;IACI,6BAA6B;IAC7B,sBAAsB;IACtB,SAAS;IACT,wBAAwB;IACxB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;;;GAGG;;AAEH;IACI,SAAS;IACT,UAAU;IAEV,sBAAsB;IACtB,kBAAkB;IAClB,wBAAwB;IAExB,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB;;;6BAGyB;IACzB,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,UAAU;IAEV,kCAAkC;IAClC,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,cAAc;IACd,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,wCAAwC;IACxC,YAAY;IACZ,mBAAmB;IACnB,gCAAgC;IAChC,2BAA2B;IAC3B,yBAAyB;IAGzB,iBAAiB;IACjB,4DAA4D;IAC5D,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,8DAA8D;AAClE;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,gDAAgD;IAChD,YAAY;AAChB;;AAEA;;;;;;;GAOG;;AAEH;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,UAAU;IACV,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX;AACJ;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,uCAAuC;IACvC,mCAAmC;IACnC,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,kCAAkC;IAClC,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,2DAA2D;IAC3D,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,oCAAoC;IACpC,2DAA2D;IAC3D,qCAAqC;IACrC,uCAAuC;AAC3C;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,eAAe;IACf,gCAAgC;AACpC;;;;AAIA;;;IAGI,qBAAqB;IACrB,4BAA4B;AAChC","sourcesContent":[":host ::ng-deep .ui-widget {\r\n    font-size: 13px;\r\n}\r\n\r\n.brandName {\r\n    left: 14px;\r\n    top: 8px;\r\n    font-size: 22px;\r\n    color: #165788;\r\n}\r\n\r\n.app-name {\r\n    color: white;\r\n    margin-left: 8px;\r\n    font-size: 28px;\r\n    /* font-weight: bold; */\r\n    vertical-align: -8px;\r\n    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);\r\n    font-family: Segoe UI;\r\n    font-weight: 100;\r\n}\r\n\r\n.app-res {\r\n    color: white;\r\n    margin-left: 85px;\r\n    font-size: 28px;\r\n    /* font-weight: bold; */\r\n    vertical-align: -8px;\r\n    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);\r\n    font-family: Segoe UI;\r\n    font-weight: 100;\r\n}\r\n\r\n#sideoption a span {\r\n    position: relative;\r\n    top: 8px;\r\n}\r\n\r\n/* .sidebarDiv ul li ,.sidebarDiv ul li:hover {\r\n     border: none !important; \r\n} */\r\n\r\n.even-list-border a:hover {\r\n    border-left: 5px solid #165788 !important;\r\n    box-shadow: 1px 1px 1px 1px rgba(0, 0, 0, 0.3);\r\n    transform: scale(1.03);\r\n    font-weight: bold;\r\n}\r\n\r\n.sidebarDiv {\r\n    display: block;\r\n    /* margin: 0.2em; */\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    position: relative;\r\n    width: auto;\r\n    /* height: 569px; */\r\n    /* min-height: -webkit-fill-available; */\r\n    /* max-height: 545px; */\r\n    /* border-radius: 5px; */\r\n    /* box-shadow: 3px 3px 15px 5px #888888;*/\r\n}\r\n\r\n.app-name-suffix {\r\n    color: white;\r\n    margin-left: 10px;\r\n    font-size: 15px;\r\n    /* font-weight: bold; */\r\n    vertical-align: -8px;\r\n    text-shadow: 2px 2px 3px rgba(22, 87, 136, 0.8);\r\n    font-family: Segoe UI;\r\n}\r\n\r\n.sidebar-collapse {\r\n    display: none !important;\r\n    transition: all 0.2s ease-out !important;\r\n}\r\n\r\n.main-content-no-margin {\r\n    margin-left: 0px !important;\r\n    transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.permitname-show {\r\n    float: right !important;\r\n    width: 20% !important;\r\n    text-align: left !important;\r\n}\r\n\r\n/* :host ::ng-deep .clsBreadCrumbs{\r\n    cursor: pointer;\r\n    background-color: red !important;\r\n    border: none !important;\r\n    padding: 0px !important;\r\n} */\r\n\r\n.leftTopMenu:hover {\r\n    background-color: transparent !important;\r\n}\r\n\r\n.wps-menu {\r\n    width: 54px;\r\n    height: 52px;\r\n    float: left;\r\n    background-color: #165788;\r\n    text-align: center;\r\n    padding-top: 14px;\r\n}\r\n\r\n.wps-menu {\r\n    cursor: pointer;\r\n    position: relative;\r\n}\r\n\r\n.wps-menu:hover {\r\n    background-color: rgb(18, 84, 138);\r\n}\r\n\r\n.launcher-icon {\r\n    height: 16px;\r\n    width: 16px;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    position: absolute;\r\n}\r\n\r\n.launcher-icon-close {\r\n    height: 22px;\r\n    width: 22px;\r\n    margin-top: 11.5px;\r\n    margin-bottom: 11.5px;\r\n}\r\n\r\n.app-launcher {\r\n    position: fixed;\r\n    box-shadow: rgba(0, 0, 0, 0.22) 0px 25.6px 57.6px 0px, rgba(0, 0, 0, 0.18) 0px 4.8px 14.4px 0px;\r\n    -webkit-animation-name: slideInFrames;\r\n    animation-name: slideInFrames;\r\n    position: absolute;\r\n    z-index: 1000000;\r\n    background-color: #fff;\r\n    width: 320px;\r\n    min-width: 320px;\r\n    max-width: 320px;\r\n    box-sizing: border-box;\r\n    outline: none;\r\n    overflow-y: auto;\r\n    visibility: visible;\r\n    pointer-events: auto;\r\n    top: 0;\r\n    left: 0;\r\n    right: auto;\r\n    height: 100vh;\r\n    -webkit-transform-origin: top left;\r\n    -ms-transform-origin: top left;\r\n    transform-origin: top left;\r\n    -webkit-animation-duration: .18s;\r\n    animation-duration: .18s;\r\n    -webkit-animation-timing-function: ease;\r\n    animation-timing-function: ease;\r\n}\r\n\r\n.app-launcher-close-btn {\r\n    background-color: transparent;\r\n    box-sizing: border-box;\r\n    border: 0;\r\n    margin: 70px 5px 5px 5px;\r\n    padding: 0;\r\n    min-width: 0;\r\n    width: 46px;\r\n    height: 46px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    transition: background-color 83ms linear;\r\n}\r\n\r\n/* .app-launcher-close-btn:hover {\r\n    background-color: #dbdad7!important;\r\n    transition: background-color .167s linear;\r\n} */\r\n\r\n.launcher-nav {\r\n    margin: 0;\r\n    outline: 0;\r\n    -webkit-box-sizing: border-box;\r\n    box-sizing: border-box;\r\n    position: relative;\r\n    padding: 10px 22px 0 0px;\r\n    -webkit-transition: none;\r\n    transition: none;\r\n    width: 310px;\r\n    background-color: #ffffff;\r\n}\r\n\r\n.link-text {\r\n    margin-top: 20px;\r\n    margin-left: 9px;\r\n    font-size: 24px;\r\n}\r\n\r\n.menu-list {\r\n    display: block;\r\n    list-style-type: disc;\r\n    /* margin-block-start: 1em;\r\n    margin-block-end: 1em;\r\n    margin-inline-start: 0px;\r\n    margin-inline-end: 0px; */\r\n    /* padding-inline-start: 40px;  */\r\n    list-style: none;\r\n}\r\n\r\n.menu-list-item {\r\n    min-height: 40px;\r\n    cursor: pointer;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    padding: 0;\r\n    -webkit-transition: background-color 267ms;\r\n    transition: background-color 267ms;\r\n    margin-left: 8px;\r\n    float: left;\r\n    width: 100%;\r\n    display: block;\r\n    box-shadow: 2px 2px 5px rgba(204, 204, 204, 0.5);\r\n    margin-top: 14px;\r\n}\r\n\r\n.menu-list-item a {\r\n    display: flex;\r\n    position: relative;\r\n    box-sizing: border-box;\r\n    border: 1px solid transparent !important;\r\n    height: 48px;\r\n    line-height: normal;\r\n    text-decoration: none !important;\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    transition: border-color 83ms linear, box-shadow 83ms linear;\r\n    color: rgb(0, 120, 215);\r\n}\r\n\r\n.menu-list-item a:hover {\r\n    border-color: #f4f4f4 !important;\r\n    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .1);\r\n    transition: border-color .167s linear, box-shadow .167s linear;\r\n}\r\n\r\n.menu-list-item-icon {\r\n    font-size: 26px;\r\n    color: inherit;\r\n    margin: 10px 15px;\r\n    display: inline-block;\r\n    line-height: 1;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    display: inline-block;\r\n    text-decoration: none;\r\n    text-align: center;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    line-height: 1em;\r\n    width: 30px;\r\n}\r\n\r\n.menu-list-item-text {\r\n    color: #212121;\r\n    font-size: 16px;\r\n    margin-top: 14px;\r\n    margin-left: 14px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    text-align: left;\r\n    white-space: nowrap;\r\n    transition: color 83ms linear;\r\n}\r\n\r\n.border-right {\r\n    /* border: 1px solid rgba(204, 204, 204, 0.5); */\r\n    margin: -1px;\r\n}\r\n\r\n/* :host ::ng-deep .p-toast .p-toast-message {\r\n    border: 1px solid #165788!important;\r\n    border-radius: 3px;\r\n    background: #f4f4f4!important;\r\n    -moz-box-shadow: 3px 3px 12px #165788;\r\n    -webkit-box-shadow: 3px 3px 12px #165788;\r\n    box-shadow: 3px 3px 12px #165788\r\n} */\r\n\r\n:host ::ng-deep .p-toast .p-toast-message-content {\r\n    padding: 0 !important;\r\n    display: unset !important;\r\n}\r\n\r\n:host ::ng-deep .p-toast .p-toast-close-icon {\r\n    color: #fff !important;\r\n}\r\n\r\n:host ::ng-deep .p-overlaypanel-content {\r\n    background-color: #ffffff !important;\r\n    color: #333333;\r\n    padding: 0;\r\n    border: 1px solid #c8c8c8;\r\n    border-radius: 0;\r\n}\r\n\r\n.toast-header {\r\n    background-color: #165788;\r\n    color: #fff;\r\n    padding: 1px 1px 1px 10px !important\r\n}\r\n\r\n.notification-count {\r\n    margin-top: -10px;\r\n    display: block;\r\n    margin-right: 4px;\r\n}\r\n\r\n.notification {\r\n    position: absolute;\r\n    right: 1px;\r\n    top: 2px;\r\n    min-width: 26px;\r\n    height: 26px;\r\n    border-radius: 50%;\r\n    font-size: 15px;\r\n    font-weight: 100;\r\n    text-align: center;\r\n    color: #ffffff;\r\n    box-shadow: 0 0 4px 0 rgba(0, 0, 0, .2);\r\n    border: 1px solid rgba(0, 0, 0, .2);\r\n    box-sizing: border-box;\r\n    background-color: red;\r\n}\r\n\r\n.app-launcher-close {\r\n    display: flex;\r\n    font-weight: 600;\r\n    background: transparent !important;\r\n    border: 0;\r\n    padding: 0;\r\n    padding-left: 2px;\r\n    min-width: 22px;\r\n    height: auto;\r\n    text-decoration: none !important;\r\n    cursor: pointer;\r\n    font-size: 22px;\r\n    position: absolute;\r\n    top: 11px;\r\n    left: 284px;\r\n}\r\n\r\n.app-launcher-close:hover {\r\n    background-color: lightgrey !important;\r\n    transition: background-color .167s linear;\r\n}\r\n\r\n.bg-transparent {\r\n    background: transparent !important;\r\n}\r\n\r\n.bg-fullscreen {\r\n    background: url('/assets/Images/background.png') !important;\r\n    background-size: 100% 100% !important;\r\n    background-repeat: no-repeat !important;\r\n}\r\n\r\n.bg-full-grey {\r\n    /* background: #f2f2f2 !important; */\r\n    background: url('/assets/Images/background.png') !important;\r\n    background-size: 100% 100% !important;\r\n    background-repeat: no-repeat !important;\r\n}\r\n\r\n.profile-initials {\r\n    height: 32px;\r\n    width: 32px;\r\n    background-color: white;\r\n    color: #165788;\r\n    line-height: 32px;\r\n    display: inline-block;\r\n    margin-right: 5px;\r\n    border-radius: 50%;\r\n    text-align: center;\r\n    font-weight: 100;\r\n    font-family: Segoe UI;\r\n    font-size: 16px;\r\n}\r\n\r\n:host ::ng-deep .p-toast-icon-close {\r\n    position: absolute;\r\n    top: 0.25em;\r\n    right: 0.25em;\r\n    cursor: pointer;\r\n    display: inline-block !important;\r\n}\r\n\r\n\r\n\r\n:host ::ng-deep .p-toast,\r\n.h5,\r\nh5 {\r\n    padding: 0 !important;\r\n    padding-left: 5px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
